import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fieldOversightApi } from "@/features/production/services/fieldOversightApi";

export const useFieldOversightLatestCheckIns = (
  search?: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["field-oversight", "latest-check-ins", search ?? ""],
    queryFn: () => fieldOversightApi.getLatestCheckIns(search?.trim() || undefined),
    enabled: options?.enabled ?? true,
    staleTime: 30 * 1000,
  });
};

export const useFieldOversightMissedReport = (params?: {
  fromUtc?: string;
  toUtc?: string;
  agronomistUserId?: string;
}, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["field-oversight", "missed-check-ins", params?.fromUtc ?? "", params?.toUtc ?? "", params?.agronomistUserId ?? ""],
    queryFn: () => fieldOversightApi.getMissedCheckInReport(params),
    enabled: options?.enabled ?? true,
    staleTime: 30 * 1000,
  });
};

export const useFieldOversightAgronomists = (enabled = true) => useQuery({
  queryKey: ["field-oversight", "agronomists"],
  queryFn: fieldOversightApi.getAgronomists,
  enabled,
  staleTime: 5 * 60 * 1000,
});

export const useFieldOversightReportConfiguration = (enabled = true) => useQuery({
  queryKey: ["field-oversight", "report-configuration"],
  queryFn: fieldOversightApi.getReportConfiguration,
  enabled,
});

export const useUpdateFieldOversightReportConfiguration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fieldOversightApi.updateReportConfiguration,
    onSuccess: (data) => queryClient.setQueryData(
      ["field-oversight", "report-configuration"],
      data
    ),
  });
};
